module.exports = __webpack_public_path__ + "img/three_crosses.cbc7da98.jpg";